import _nl2br from 'react-nl2br';

export const nl2br = _nl2br as unknown as typeof _nl2br.default;
